import React from 'react';

// Responsive container: full width on desktop, mobile-optimized on small screens
const ResponsiveFrame = ({ children }) => {
  return (
    <div className="min-h-screen w-full bg-neutral-50">
      <div className="relative w-full min-h-screen bg-white">
        {children}
      </div>
    </div>
  );
};

export default ResponsiveFrame;
